import dayjsGenerateConfig from 'antd/node_modules/rc-picker/lib/generate/dayjs'
import generatePicker from 'antd/es/date-picker/generatePicker'
import 'antd/es/date-picker/style/index'

const DatePicker = generatePicker(dayjsGenerateConfig)

export default DatePicker
